export default __webpack_public_path__ + "static/media/kami-street.17927eb4.png";